import { useEffect, useState } from 'react';
import LockoutButton from './components/LockoutButton';
import MiniGamesBox from './components/MiniGamesBox';
import SocketConnection from './utils/SocketConnection';
import MirrorConnection from './utils/MirrorConnection';

var testMiniGameRunning = false;

function ContestantView(props) {

  // window.screen.availWidth - window.innerWidth === 0

  const [ screenIsMaximized, setScreenIsMaximized ] = useState(true);
  const [ harrassmentInterval, setHarrassmentInterval ] = useState(null);
  const [ hostViewUrl, setHostViewUrl ] = useState('');
  const [ hostViewStyles, setHostViewStyles ] = useState({});

  const TEMP_PLAYER_NUMBER_FETCH_THIS_FROM_URL = props.player;

  const handleHostViewUrlChange = (url) => {
    const bannerContainerDiv = document.querySelector('div.banner__container');
    setHostViewStyles({
      position: 'absolute',
      zIndex: -900,
      left: bannerContainerDiv ? bannerContainerDiv.offsetLeft : null,
      top: bannerContainerDiv ? bannerContainerDiv.offsetTop : null,
      width: bannerContainerDiv ? `${bannerContainerDiv.clientWidth}px` : null,
      height: bannerContainerDiv ? `${bannerContainerDiv.clientHeight}px` : null
    });
    if (url.length > 0) {
      setHostViewUrl(url);
      // setHostViewUrl(`${url}&autostart`);
    } else {
      setHostViewUrl('');
    }
  };


  const handleButtonClick = (e) => {
    if (SocketConnection.connected) {
      SocketConnection.sendButtonPress();
    } else {
      alert("Not connected!");
    }
  };


  useEffect(() => {
    if (!SocketConnection.connected && !SocketConnection.connecting) {
      SocketConnection.connect(TEMP_PLAYER_NUMBER_FETCH_THIS_FROM_URL);
      SocketConnection.hostViewUrlChangeHandler = handleHostViewUrlChange;
    }
    if (!MirrorConnection.connected && !MirrorConnection.connecting) {
      MirrorConnection.connect(TEMP_PLAYER_NUMBER_FETCH_THIS_FROM_URL);
    }
    setInterval(() => {
      // this will be true if the user's screen is maximized.
      setScreenIsMaximized(window.screen.availWidth - window.innerWidth === 0);
    }, 1000);


    // hard coded host view url
    document.onclick = () => {
      handleHostViewUrlChange('https://vdo.ninja/?view=y2hQ6iz:s&solo&room=Rental_Rewind&autostart');
      document.onclick = null;
    };
    

  }, []);


  useEffect(() => {
    if (!screenIsMaximized) {
      alert('YOUR SCREEN MUST BE MAXIMIZED IN ORDER TO PLAY.');
    }
  }, [ screenIsMaximized ]);


  return (
    <div className="container">
        <div className="banner__container">
            <MiniGamesBox player={props.player} SocketConnection={SocketConnection} MirrorConnection={MirrorConnection}/>
        </div>
        <div className='handbuttondiv'>
          <button onClick={handleButtonClick} className='handbutton'></button>
        </div>
        {/* <img className="button-image" src="images/mockup-pressed.png" alt="button"/> */}
        {/* <div className="button__container">
            <LockoutButton SocketConnection={SocketConnection} />
        </div>*/}

        { hostViewUrl.length > 0 &&
        <div className="videofeed" style={hostViewStyles}>
          <iframe allow="autoplay" src={hostViewUrl}></iframe>
        </div>
        }
        
    </div>
  );
}

export default ContestantView;
